import NextLink from 'next/link'
import { twMerge } from 'tailwind-merge'

type Props = {
  className?: string
  size?: string
} & React.ComponentPropsWithoutRef<'div'>

export default function Logo({ className, size }: Props) {
  return (
    <div className={twMerge('lg:ml-12', className)}>
      <NextLink href='/'>
        <img alt='Cruz Logo' src='/img/cruzLogo.svg' className={twMerge('block dark:hidden', size)} />
        <img alt='Cruz Logo Rev' src='/img/cruzLogoRev.svg' className={twMerge('hidden dark:block dark:opacity-80', size)} />
      </NextLink>
    </div>
  )
}
